import { io } from "socket.io-client";

let _userUUID = JSON.parse(localStorage.getItem('_user'));
let _user_uuid = _userUUID ? _userUUID.uuid : "";
export const socket = io(`${process.env.REACT_APP_SOCKET_URL}`, { transports: ['websocket'], query: `userUUID=${_user_uuid}` });

export const _init = () => {
    socket.on('connect', function () {
        console.log("connect", socket.id);
        // socket.emit("addUser", _user_uuid);
    });
    socket.on('disconnect', function () {
        console.log("disconnect");
    });
}